import createConsoleLogger from '@exodus/logger';

const LOGGER_DEBUG_FLAG = 'logger!enabled';

function isDebugEnabled(): boolean {
  try {
    return window.localStorage.getItem(LOGGER_DEBUG_FLAG) === '1';
  } catch {
    return false;
  }
}

const noop = () => {};

const createLogger = (namespace?: string) => {
  const logger = createConsoleLogger(namespace);

  const wrapMethod = (method: any) => {
    const enabled = !import.meta.env.PROD || isDebugEnabled();
    return enabled ? method : noop;
  };

  return {
    trace: wrapMethod(logger.trace),
    debug: wrapMethod(logger.debug),
    log: wrapMethod(logger.log),
    info: wrapMethod(logger.info),
    warn: wrapMethod(logger.warn),
    error: wrapMethod(logger.error),
  };
};

export default createLogger;
